import { cva } from "class-variance-authority";

export const registrationFeedbackSurveyBannerStyles = cva([
  "flex w-full items-center gap-3 bg-[#E8F4FC] px-4 py-4",
  "lg:items-start lg:px-8",
]);

export const registrationFeedbackSurveyBannerTextStyles = cva([
  "m-0 font-[Poppins,sans-serif] text-sm font-normal leading-5 tracking-[0.25px] text-[#003049]",
  "lg:text-base lg:leading-6 lg:tracking-[0.5px]",
]);
